import * as React from 'react';

import type { VariantProps } from 'class-variance-authority';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { cva } from 'class-variance-authority';

const textareaVariants = cva(
  cn(
    'flex min-h-[90px] w-full rounded-none p-0 text-sm lg:text-base placeholder:text-muted-foreground border-b border-b-black/15',
    'focus-within:border-b-black/50 focus-within:ring-0 focus-visible:outline-none focus-visible:ring-0 focus:ring-0 focus:outline-none',
  ),
  {
    variants: {
      variant: {
        outlined: ['bg-transparent', 'ea-textarea__outlined'],
        filled: ['bg-transparent', 'ea-textarea__filled'],
      },
      rounded: {
        default: 'rounded-none',
        none: 'rounded-none',
      },
    },
    defaultVariants: {
      rounded: 'default',
      variant: 'filled',
    },
  },
);

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textareaVariants> & {
    className?: string;
    classNames?: string;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, classNames, ...props }, ref) => {
    return (
      <textarea
        style={{ resize: 'none' }}
        className={cn(
          textareaVariants({
            variant: props.variant,
            rounded: props.rounded,
            className: cn(
              'ea-textarea bg-transparent focus-within:ring-0',
              props['aria-invalid'] && 'ea-textarea--invalid border-destructive text-destructive',
              className,
              classNames,
            ),
          }),
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
